"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfDigitalKeyService = exports.InstallationState = exports.DigitalKeyRemovalState = exports.DigitalKeyState = void 0;
const types_1 = require("../../shared/types");
var DigitalKeyState;
(function (DigitalKeyState) {
    DigitalKeyState[DigitalKeyState["ENDED"] = 0] = "ENDED";
    DigitalKeyState[DigitalKeyState["UNKNOWN"] = 1] = "UNKNOWN";
    DigitalKeyState[DigitalKeyState["CONFIRMED"] = 2] = "CONFIRMED";
    DigitalKeyState[DigitalKeyState["ACCEPTED"] = 3] = "ACCEPTED";
    DigitalKeyState[DigitalKeyState["USED"] = 4] = "USED";
})(DigitalKeyState || (exports.DigitalKeyState = DigitalKeyState = {}));
var DigitalKeyRemovalState;
(function (DigitalKeyRemovalState) {
    DigitalKeyRemovalState[DigitalKeyRemovalState["INREMOVAL"] = 0] = "INREMOVAL";
    DigitalKeyRemovalState[DigitalKeyRemovalState["REMOVALFAILED"] = 1] = "REMOVALFAILED";
    DigitalKeyRemovalState[DigitalKeyRemovalState["UNKNOWN"] = 2] = "UNKNOWN";
})(DigitalKeyRemovalState || (exports.DigitalKeyRemovalState = DigitalKeyRemovalState = {}));
var InstallationState;
(function (InstallationState) {
    InstallationState[InstallationState["SUCCEEDED"] = 0] = "SUCCEEDED";
    InstallationState[InstallationState["FAILED"] = 1] = "FAILED";
    InstallationState[InstallationState["UNKNOWN"] = 2] = "UNKNOWN";
})(InstallationState || (exports.InstallationState = InstallationState = {}));
class VcfDigitalKeyService {
    constructor(vcfDigitalKeyClient) {
        this.vcfDigitalKeyClient = vcfDigitalKeyClient;
    }
    async getDigitalKeys(vin, devicePlatform) {
        var _a, _b, _c;
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        const mobileKeysListResponse = await this.vcfDigitalKeyClient.getMobileKeysList(vin, isWcar);
        const mappedKeys = (_c = (_b = (_a = mobileKeysListResponse.data) === null || _a === void 0 ? void 0 : _a.permissionList) === null || _b === void 0 ? void 0 : _b.map(this.transformPermissionToDigitalKey)) !== null && _c !== void 0 ? _c : [];
        return mappedKeys.filter(this.filterKeysWithValidStates);
    }
    async getDigitalKeyStatus(vin, devicePlatform) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        const response = await this.vcfDigitalKeyClient.getMobileKeysStatus(vin, isWcar);
        return {
            trustedDevices: this.filterTrustedDevices((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.trusteddevice) !== null && _b !== void 0 ? _b : []),
            freeMobileKeys: (_e = (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.serviceStatus) === null || _d === void 0 ? void 0 : _d.keyVoucherFreeCount) !== null && _e !== void 0 ? _e : 0,
            userRole: (_h = (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.serviceStatus) === null || _g === void 0 ? void 0 : _g.userRole) !== null && _h !== void 0 ? _h : types_1.Role.UNKNOWN
        };
    }
    async deleteTrustedDevice(id, vin, devicePlatform) {
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        await this.vcfDigitalKeyClient.deleteTrustedDevice(id, vin, isWcar);
    }
    async deleteDigitalKey(id, vin, devicePlatform) {
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        await this.vcfDigitalKeyClient.deleteMobileKeyPermission(id, vin, isWcar);
    }
    async renameDigitalKey(id, alias, vin, devicePlatform) {
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        await this.vcfDigitalKeyClient.putMobileKeyPermission(id, alias, vin, isWcar);
    }
    filterKeysWithValidStates(key) {
        const validState1 = key.state === DigitalKeyState.CONFIRMED || key.state === DigitalKeyState.ACCEPTED;
        const validState2 = key.state === DigitalKeyState.USED && key.installationState === InstallationState.SUCCEEDED;
        const validState3 = key.state === DigitalKeyState.ENDED
            && (key.removalState === DigitalKeyRemovalState.INREMOVAL || key.removalState === DigitalKeyRemovalState.REMOVALFAILED)
            && key.installationState === InstallationState.SUCCEEDED;
        return validState1 || validState2 || validState3;
    }
    filterTrustedDevices(trustedDevices) {
        return trustedDevices.filter(this.trustedDeviceIsRegistered).map(this.transformVcfTrustedDevice);
    }
    transformPermissionToDigitalKey(permission) {
        var _a, _b, _c, _d, _e, _f;
        const { permissionId, frontendAlias, mkUserUserName, expirationTimestamp, state, removalState, mkAdministratorUserName, installationState } = permission;
        return {
            id: permissionId,
            alias: frontendAlias,
            userName: mkUserUserName,
            expirationTimestamp: expirationTimestamp,
            state: (_b = DigitalKeyState[(_a = state === null || state === void 0 ? void 0 : state.toUpperCase()) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : DigitalKeyState.UNKNOWN,
            installationState: (_d = InstallationState[(_c = installationState === null || installationState === void 0 ? void 0 : installationState.toUpperCase()) !== null && _c !== void 0 ? _c : '']) !== null && _d !== void 0 ? _d : InstallationState.UNKNOWN,
            removalState: (_f = DigitalKeyRemovalState[(_e = removalState === null || removalState === void 0 ? void 0 : removalState.toUpperCase()) !== null && _e !== void 0 ? _e : '']) !== null && _f !== void 0 ? _f : DigitalKeyRemovalState.UNKNOWN,
            isOwnKey: mkUserUserName ? VcfDigitalKeyService.equalsIgnoreCase(mkUserUserName, mkAdministratorUserName) : false,
        };
    }
    trustedDeviceIsRegistered(vcfTrustedDevice) {
        return vcfTrustedDevice.status === 'REGISTERED';
    }
    transformVcfTrustedDevice(vcfTrustedDevice) {
        const { teeId, primaryUserID, imei } = vcfTrustedDevice;
        return { id: teeId, primaryUserId: primaryUserID, imei };
    }
    static equalsIgnoreCase(str1, str2) {
        if (str1 && str2) {
            return str1.localeCompare(str2, undefined, { sensitivity: 'base' }) === 0;
        }
        return false;
    }
    ;
}
exports.VcfDigitalKeyService = VcfDigitalKeyService;
//# sourceMappingURL=VcfDigitalKeyService.js.map